import { render } from "./Activation2Form.vue?vue&type=template&id=701a0f13"
import script from "./Activation2Form.vue?vue&type=script&lang=js"
export * from "./Activation2Form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__